module.exports = __webpack_public_path__ + "static/media/char_sheet_full.de3b3a5f.png";